import { OfflineState } from '@/state/offline-management'
import { offlineStateActions } from '@/state/actions'

import { MdOutlineWifiOff } from 'react-icons/md'
import { Popconfirm, Tooltip } from 'antd'

export default function OfflineIndicator() {
  const componentToRender = () => (
    <Tooltip title='Sin conexión a internet' placement='bottom'>
      <MdOutlineWifiOff className='indicator offline' />
    </Tooltip>
  )

  if (OfflineState.existNetworkConnection.value) {
    return (
      <Popconfirm
        title={'¿Deseas activar la conexión a internet?'}
        onConfirm={() => offlineStateActions.switchConnection()}
        okText='Sí, reconectar'
      >
        {componentToRender()}
      </Popconfirm>
    )
  }

  if (!OfflineState.existNetworkConnection.value) {
    return componentToRender()
  }
}
